import useSWR from "swr";
import { getPersistedChordsheet } from "./LyricsPartsPersistence";
import { useChordsheetPersistenceStatus } from "./ChordsheetPersistenceState";
import { LyricsPart } from "./LyricsExtractor";

export function useCachedLyricsParts(songId: string): LyricsPart[] {
  const persistenceStatus = useChordsheetPersistenceStatus();

  // Keying by [songId, persistenceStatus] makes SWR dedupe/share the fetch across
  // every component reading the same song, and refetch whenever a delta update
  // completes elsewhere in the app.
  const { data } = useSWR(
    [songId, persistenceStatus],
    () => getPersistedChordsheet(songId),
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return data ?? [];
}
